import React, { useState, useEffect } from 'react';
import { Search } from 'lucide-react';

export const CodeNAFAutocomplete = ({ value, onChange, required = false }) => {
  const [inputValue, setInputValue] = useState(value || '');
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [allCodes, setAllCodes] = useState([]);

  useEffect(() => {
    loadCodesNAF();
  }, []);

  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  const loadCodesNAF = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/eligibility-rules`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      const data = await response.json();
      setAllCodes(data || []);
      console.log(`✓ ${data.length} codes NAF chargés`);
    } catch (error) {
      console.error('Erreur chargement codes NAF:', error);
    }
  };

  const handleInputChange = (term) => {
    setInputValue(term);
    onChange(term);
    
    if (term.length < 2) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    const filtered = allCodes.filter(code => 
      code.naf_code_label.toLowerCase().includes(term.toLowerCase()) ||
      code.libelle.toLowerCase().includes(term.toLowerCase())
    ).slice(0, 8);

    setSuggestions(filtered);
    setShowSuggestions(filtered.length > 0);
  };

  const selectCode = (code) => {
    setInputValue(code.naf_code_label);
    onChange(code.naf_code_label);
    setShowSuggestions(false);
  };

  return (
    <div className="relative">
      <input
        type="text"
        required={required}
        value={inputValue}
        onChange={(e) => handleInputChange(e.target.value)}
        onFocus={() => inputValue.length >= 2 && suggestions.length > 0 && setShowSuggestions(true)}
        onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
        className="w-full px-3 py-2 border border-[#BFC6CC] rounded-lg focus:ring-2 focus:ring-[#397DFF] font-mono text-sm"
        placeholder="Ex: C2229 ou tapez pour rechercher"
      />

      {showSuggestions && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-[#BFC6CC] rounded-lg shadow-lg max-h-60 overflow-y-auto">
          {suggestions.map((code) => (
            <button
              key={code.id}
              type="button"
              onMouseDown={(e) => {
                e.preventDefault();
                selectCode(code);
              }}
              className="w-full px-4 py-3 text-left hover:bg-[#F5F6F9] border-b border-[#BFC6CC] last:border-0"
            >
              <div className="font-mono font-semibold text-[#191D1E]">{code.naf_code_label}</div>
              <div className="text-sm text-[#687175] mt-1">{code.libelle}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
